export const environment = {
	production: true,
	apiUrl: 'https://api.gappel.com',
	fileServer: 'https://files.gappel.com',
	stripeCustomerPortalLink:
		'https://billing.stripe.com/p/login/8wM03g0Z4g7Rb608ww',
	stripePublishableKey:
		'pk_live_51R80gSFy8T17NmqFrAFwvm8oazDPAnuGbcZhJpCcv5lo8YfRjvADqaXfkHyeK0bBedBlfZ7rijM1seUl4FWpwQGK00p1SIl7Q4',
	stripeMenuStarterMonthlyLink:
		'https://buy.stripe.com/dRmaEX0tX4Yz6IW9Bi5EY05',
	stripeMenuStarterYearlyLink: 'https://buy.stripe.com/4gM28r1y1fDd6IWaFm5EY06',
	stripeMenuProMonthlyLink: 'https://buy.stripe.com/eVq4gza4x9eP1oC9Bi5EY04',
	stripeMenuProYearlyLink: 'https://buy.stripe.com/fZufZh4Kd4Yz9V85l25EY08',
};
